import { MdArrowForwardIos } from "react-icons/md";
import icon from "../../../assests/solutionImages/PdfGallery/Themeicon.svg";


function PdfGalleryTheme({card}) {
  console.log(card);

  return (
    <div className="flex p-2  md:py-4 justify-center bg-gray-400 ">
      <div className="relative max-w-[393px] h-screen overflow-y-auto scrollbar-hide bg-[#1F73D7] rounded-xl shadow-lg">
        {/* Background image */}
        <div className="relative w-full h-48 overflow-hidden">
          <img
            src={card?.backgroundImage}
            alt="Background"
            className="w-full h-full object-cover"
          />
        </div>

        {/* Profile image */}
        <div className="absolute top-[8rem] left-1/2 transform -translate-x-1/2 z-10">
          <div className="w-32 h-32 rounded-full overflow-hidden">
            <img
              src={card?.profileImage}
              alt="Profile"
              className="w-full h-full object-cover"
            />
          </div>
        </div>

        {/* Company info */}
        <div className="text-center pt-[6rem] px-4">
          <h2 className="text-3xl font-bold text-white">
            {card?.data?.companyName || "Company Name"}
          </h2>
          <p className="text-white mt-2">
            {card?.data?.description || "This is a sample company description."}
          </p>
        </div>

        {/* PDF Gallery Items */}
        <div className="px-4 pb-4 mt-6">
          <div className="grid grid-cols-1 gap-3">
            {card?.data?.pdfItems && card.data.pdfItems.length > 0 ? (
              card.data.pdfItems.map((item, index) => (
                <div
                  key={item.key || index}
                  className="bg-white rounded-xl py-4 shadow-md hover:shadow-lg transition-shadow cursor-pointer"
                  onClick={() => window.open(item.pdfUrl, '_blank')}
                >
                  <div className="flex justify-between items-center gap-3 px-4 w-full h-full">
                    {/* Icon or Thumbnail */}
                    <div className="flex-shrink-0 w-12 h-12">
                      {item.thumbnail ? (
                        <img
                          src={item.thumbnail}
                          alt="PDF thumbnail"
                          className="w-12 h-12 object-cover rounded"
                        />
                      ) : (
                        <img
                          src={icon}
                          alt="PDF icon"
                          className="w-12 h-12"
                        />
                      )}
                    </div>

                    {/* Text content */}
                    <div className="flex-grow min-w-0">
                      <p className="text-lg font-normal text-[#1F73D7] truncate break-all break-words">
                        {item.title}
                      </p>
                      {item.showDescription && item.description ? (
                        <p className="text-sm text-[#444444] truncate break-all break-words">
                          {item.description}
                        </p>
                      ) : (
                        null
                        // <p className="text-sm text-[#444444]">
                        //   Visit for more information
                        // </p>
                      )}
                    </div>

                    {/* Arrow icon */}
                    <div className="flex-shrink-0 w-6 h-6 text-[#444444] flex items-center justify-center">
                      <MdArrowForwardIos />
                    </div>
                  </div>
                </div>
              ))
            ) : null
            //  (
            //   <div className="bg-white rounded-xl py-4 opacity-50">
            //     <div className="flex justify-center items-center gap-3 px-4 w-full h-full">
            //       <div className="flex-shrink-0">
            //         <img src={icon} alt="PDF icon" className="w-12 h-12" />
            //       </div>
            //       <div className="flex-grow">
            //         <p className="text-lg font-bold text-[#1F73D7]">PDF Gallery</p>
            //         <p className="text-sm text-[#444444]">Add PDFs to display here</p>
            //       </div>
            //       <div className="flex-shrink-0 text-[#444444]">
            //         <MdArrowForwardIos />
            //       </div>
            //     </div>
            //   </div>
            // )
            }
          </div>
        </div>
      </div>
    </div>
  );
}

export default PdfGalleryTheme;
